import { twJoin } from "tailwind-merge";

import { urlify } from "../../helpers/text";

type MultiLineContentProps = {
  align?: "start" | "center";
} & (
  | {
      children: string;
      shouldHighlightLinks: boolean;
    }
  | {
      children: React.ReactNode;
      shouldHighlightLinks?: never;
    }
);

export function MultiLineContent({
  children,
  shouldHighlightLinks,
  align = "start",
}: MultiLineContentProps): React.ReactNode {
  const content = shouldHighlightLinks ? urlify(children) : children;

  return (
    <span
      className={twJoin("block font-sans wrap-break-word whitespace-pre-line", align === "center" && "text-center")}
    >
      {content}
    </span>
  );
}
